import React from 'react';
import { motion } from 'framer-motion';
import { Clock, AlertCircle, TrendingDown, DollarSign, XCircle } from 'lucide-react';
const problems = [{
  icon: Clock,
  title: 'Too many resumes, not enough time',
  description: 'Drowning in applications while good candidates slip away.'
}, {
  icon: AlertCircle,
  title: 'Inconsistent screening decisions',
  description: 'Manual reviews lead to bias and missed opportunities.'
}, {
  icon: TrendingDown,
  title: 'Slow time-to-hire hurting growth',
  description: 'Open roles sit empty for months, stalling your business momentum.'
}, {
  icon: DollarSign,
  title: 'Expensive hiring mistakes',
  description: 'Bad hires cost significantly more than just their salary.'
}, {
  icon: XCircle,
  title: 'Enterprise AI tools are overkill',
  description: 'Most AI HR software is too expensive and complex for SMBs.'
}];
export function ProblemSection() {
  return <section className="py-16 md:py-24 bg-slate-50" data-id="element-54">
      <div className="max-w-7xl mx-auto px-6" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-56">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-57">
            Hiring Challenges Small Businesses Face Without AI
          </h2>
          <p className="text-lg text-slate-600" data-id="element-58">
            Traditional hiring methods are breaking down. You don't need a full
            HR tech stack—you need a solution that fits.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-59">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-sm border border-slate-100" data-id="element-60">
              <div className="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center mb-6" data-id="element-61">
                <problem.icon className="w-6 h-6 text-red-500" data-id="element-62" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-63">
                {problem.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-64">
                {problem.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}